import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '@anytag/shared-atoms';

interface NoteAggregateLastThirtyDaysProps {
  className?: string;
  message?: ReactNode;
}
export const NoteAggregateLastThirtyDays = ({ className, message }: NoteAggregateLastThirtyDaysProps) => {
  const { t } = useTranslation();

  return <TextCutter className={cn('ml-auto text-base', className)} text={message || t('aggregate last 30 days')} />;
};
